import { returnAction } from '../return-action.util';
import { ActionEnum } from '../../../enum/action.enum';
import { DesignObjectModel } from '../../../model/design-object.model';

export const saveDesignObjectDraft = (design: DesignObjectModel) => returnAction<DesignObjectModel>(ActionEnum.SAVE_DESIGN_OBJECT_DRAFT, design);
